
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { VAClientTable } from './VerificationAgencyClientTableMapper';
import { ClientModal } from './CreateClientModal';
import { useState } from 'react';

interface IVAClientData {
    results: VAClientTable;
    entriesPerPage: EntriesPerPage;
    pageNumber: number;
    filteredItemsCount: number;
    totalItemsCount: number;
    entriesPerPageChanged: (entriesPerPage: number) => void;
    pageNumberChanged: (pageNumber: number) => void;
    searchValueChanged: (searchValue: string) => void;
    columnSortingChanged: (sortOption: ColumnSortOption) => void;
    isLoading: boolean;
}

export const VerificationAgencyClientTable = (props: IVAClientData) => {

    const [showClientModal, setShowClientModal] = useState<boolean>(false);

    const handleAddClient = () => {
        setShowClientModal(true);
    };

    const closeClientUserModal = () => {
        setShowClientModal(false);
    };

    const bulkActions = [
        {
            label: "Add Client",
            action: handleAddClient
        }
    ]

    return (
        <>
            <DataTable
                key={props.totalItemsCount}
                table={props.results}
                canSearch
                entriesPerPage={props.entriesPerPage}
                pageNumber={props.pageNumber}
                filteredItemsCount={props.filteredItemsCount}
                totalItemsCount={props.totalItemsCount}
                entriesPerPageChanged={props.entriesPerPageChanged}
                pageNumberChanged={props.pageNumberChanged}
                searchValueChanged={props.searchValueChanged}
                isLoading={props.isLoading}
                bulkActions={bulkActions}
                manualSorting={true}
                columnSortingChanged={props.columnSortingChanged}
            ></DataTable>
            {showClientModal && (
                <ClientModal
                    showClientModal={showClientModal}
                    closeClientModal={closeClientUserModal}
                />
            )}
        </>
    )
}